<template>
  <div class="page">
    <div class="group_1">
      <div class="box_1" v-for="item in trainCertList" :key="item.id">
        <div class="title">
          <span>证书编号：{{ item.certNo }}</span>
        </div>
        <van-divider />

        <div class="text">证书名称:{{ item.certName }}</div>
        <div style="display: flex; align-items: center; justify-content: flex-end; margin-top: 10px">
          <span
            style="
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 13px;
              color: #ffffff;
              width: 100px;
              height: 36px;
              background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
              border-radius: 16px 16px 16px 16px;
              text-align: center;
              line-height: 36px;
            "
            @click="gotozs(item)"
            >查看证书</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { mapState } from 'vuex';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      // trainCertList:[]
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState('m_user', ['trainCertList'])
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    gotozs(item) {
      this.$router.push({
        path: '/zsCan',
        query: { certId: item.id }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.group_1 {
  padding: 10px 15px;
}
.box_1 {
  background-color: #fff;
  width: 100%;
  border-radius: 8px 8px 8px 8px;
  padding: 16px 15px;
  margin-bottom: 10px;
  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
  .text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: #777777;
  }
}
</style>
